import ResetPassword from '../components/ResetPassword'
import { resetPasswordServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const ResetPasswordWidget = injectWidget({
  widget: ResetPassword,
  serviceConfig: resetPasswordServiceConfig,
})

export default ResetPasswordWidget
